<template>
    <!-- Begin - Disclaimer Screen Modal -->
  <v-dialog
    v-model="visible"
    max-width="500px"
    @click:outside="close()"
  >
    <v-card>
      <v-card-title class="justify-center title">
        Disclaimers
      </v-card-title>
      <v-card-text>
        <v-container class="caption">
          <v-row>
            <v-col>
              <span class="red--text">1.) The PIC is ultimately responsible to validate with the POH of the aircraft.</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>2.) Airport data (runway number and length, airport elevation) were obtained from a 3rd party; some outdated information may exist.</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>6.) Application rounds up both temperature and pressure altitude to the next highest value for the short take off / landing charts.</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>7.) Assumes flaps down on landing.</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>8.) No corrections have been made for winds or non-dry runway surfaces</span>
            </v-col>
          </v-row>
        </v-container>
        </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn dense
          small
          class="white--text"
          color="red darken-4"
          @click="close()"
        >
          Close
        </v-btn><br />
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- End - Disclaimer Screen Modal -->
</template>

<script>
export default {
  name: "Disclaimers",
    data() {
      return {

    }
  },
  props: {
    visible: {type:Boolean, required: true}
  },
  methods:{
    close() {
      this.$emit('close');
    },
  }
};
</script>
